import { RouteConfig } from 'vue-router'

const routes: RouteConfig[] = [
  {
    path: '/coach',
    component: () => import('@/views/coach/Home.vue')
  },
  {
    path: '/coach/program/:id',
    component: () => import('@/views/shared/Programs/Program.vue')
  },
  {
    path: '/coach/webinars',
    component: () => import('@/views/shared/Webinar/Index.vue'),
  },
  {
    path: '/coach/webinars/:id',
    component: () => import('@/views/shared/Webinar/Details.vue'),
  },
  {
    path: '/coach/content-assignment',
    component: () => import('@/views/shared/ContentAssignment/Index.vue')
  },

  {
    path: '/coach/library',
    component: () => import('@/views/shared/Library/Index.vue'),
    redirect: '/coach/library/content',
    children: [
      {
        path: 'content',
        component: () => import('@/views/shared/Library/Content.vue')
      },
      {
        path: 'archive',
        component: () => import('@/views/shared/Library/Archived.vue')
      }
    ]
  },
  {
    path: '/coach/library/:id',
    component: () => import('@/views/shared/Library/ContentItem.vue')
  },
  {
    path: '/coach/content-assignment',
    component: () => import('@/views/shared/ContentAssignment/Index.vue')
  },
]

export default routes;